// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--zClPL","wrapper":"a10a3f92e9--wrapper--_ZJ3_","title":"a10a3f92e9--title--w4yBs","icon":"a10a3f92e9--icon--wYRgP"};